import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Stack, Checkbox, FormControlLabel, Tooltip } from "@mui/material";
const moment = require("moment");
import Download from "../../images/Download.svg";
import Print from "../../images/Print.svg";
import API from "../comman/API";
import { authHeader } from "../comman/MainFunction";
import { GET_ATTACHMENT_BY_BILLING_PROJECT_ID_URL, CHECK_STATEMENT_EXIST_IN_INVOICE_URL, ADMIN_CHECK_STATEMENT_EXIST_IN_INVOICE_URL } from "../../constants/ApiRoute";
import {
  deCryptFun,
  enCryptFun,
  zipAndDownload,
} from "../comman/CustomFunction";
import { useToast } from "../comman/CustomMessages";
import JSZip from "jszip";
import { useNavigate } from "react-router-dom";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function CreateConsolidatedInvoiceModel(props) {
  const {
    open,
    setOpen,
    handleCloseInvoice,
    selectedPeriod,
    createCloseInvoice,
    selectedInvoicePeriod,
    adminDirectCreation,
    invoiceClosedList,
    handleModelPopupInvoiceReload,
    periodIndexValues,
    adminSingleInvoiceDirectCreation,
  } = props;

  const navigate = useNavigate();

  const uniqueAdminDirectCreation = adminDirectCreation.filter(
    (item, index, self) =>
      index ===
      self.findIndex(
        (t) =>
          t.ConsolidatedInvoiceId === item.ConsolidatedInvoiceId &&
          t.ConsolidatedProjectId === item.ConsolidatedProjectId &&
          t.ConsolidatedPeriodKey === item.ConsolidatedPeriodKey
      )
  );
  const uniqueadminSingleInvoiceDirectCreation = adminSingleInvoiceDirectCreation.filter(
    (item, index, self) =>
      index ===
      self.findIndex(
        (t) =>
          t.InvoiceId === item.InvoiceId &&
          t.ProjID === item.ProjID &&
          t.PeriodKey === item.PeriodKey
      )
  );
 console.log(adminDirectCreation, 'adminDirectCreationadminDirectCreation')
 console.log(uniqueAdminDirectCreation, 'uniqueAdminDirectCreationuniqueAdminDirectCreation')
 console.log(uniqueadminSingleInvoiceDirectCreation, 'uniqueAdminDirectCreationuniqueAdminDirectCreation')
 console.log(invoiceClosedList, 'invoiceClosedListinvoiceClosedList')
  if (invoiceClosedList && invoiceClosedList.length > 0 && selectedPeriod) {
    const invoiceIdsToUpdate = invoiceClosedList.map((item) => item.invoiceId);
    selectedPeriod.forEach((statement) => {
      if (invoiceIdsToUpdate.includes(statement.InvoiceID)) {
        statement.StatusID = 4;
      }
    });
  }
  
// Ensure selectedPeriod is an array or use an empty array as a fallback
const selectedPeriodInvoiceIds = (selectedPeriod || []).map(item => item.InvoiceID);

// Filter out entries in uniqueAdminDirectCreation where InvoiceId is not in selectedPeriod
var combinedUnmatchedUniqueArray = [];
const unmatchedUniqueAdmin = (uniqueAdminDirectCreation || []).filter(item => !selectedPeriodInvoiceIds.includes(item.ConsolidatedInvoiceId));
const uniqueadminSingle = (uniqueadminSingleInvoiceDirectCreation || []).filter(item => !selectedPeriodInvoiceIds.includes(item.InvoiceId));

console.log(unmatchedUniqueAdmin, 'unmatchedUniqueAdmin');
console.log(uniqueadminSingle, 'uniqueadminSingle');


if((unmatchedUniqueAdmin && unmatchedUniqueAdmin?.length > 0) || (uniqueadminSingle && uniqueadminSingle?.length > 0)){

  let combinedArray = unmatchedUniqueAdmin.concat(uniqueadminSingle);
  combinedUnmatchedUniqueArray = combinedArray.sort((a, b) => {
    const dateA = a.CreateDate || a.LastModified;
    const dateB = b.CreateDate || b.LastModified;
    return new Date(dateA) - new Date(dateB);
  });

}

  console.log(selectedPeriod, "props from modalbox", uniqueAdminDirectCreation);
  let Invoiceobj = [
    { id: 1, value: "Statement Pending" },
    { id: 2, value: "Statement Ready" },
    { id: 3, value: "Invoice Started" },
    { id: 4, value: "Invoice Closed" },
  ];

  // Define the status constants
  const StatementOpen = "1";
  const StatementReady = "2";
  const InvoiceStarted = "3";
  const InvoiceClosed = "4";

  // const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const showToast = useToast();
  const [invoiceCheckBox, setInvoiceCheckBox] = useState([]);
  const [invoiceCheckBoxAll, setInvoiceCheckBoxAll] = useState("");
  const [statusCount, setStatusCount] = useState("");

  const attachmentDownloadFunction = async (
    selectedInvoicePeriod,
    BillingStatementID,
    UserID,
    detailsValues
  ) => {
    let data = {
      // projectId: selectedInvoicePeriod.ProjectID,
      // periodKey: selectedInvoicePeriod.PeriodKey,
      userId: UserID,
      billingStatementId: BillingStatementID,
      parentTypeId : 1
    };

    const config = {
      method: "GET",
      url: GET_ATTACHMENT_BY_BILLING_PROJECT_ID_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (
        parsedResponse &&
        parsedResponse.data &&
        parsedResponse.data.length > 0
      ) {
        downLoadAttachment(parsedResponse.data, detailsValues);
        console.log("parsedResponse", parsedResponse);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        showToast(v.message, "error");
      }
      return null; // Return null on error
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString); // Convert ISO string to Date object
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Month (0-based index)
    const day = date.getDate().toString().padStart(2, "0"); // Day
    const year = date.getFullYear(); // Year
    return `${month}${day}${year}`; // Concatenate as MMDDYYYY
  };

  const expectedFormat =
    formatDate(selectedInvoicePeriod.BillingStart) +
    formatDate(selectedInvoicePeriod.BillingEnd);

  console.log(expectedFormat, "expectedFormatexpectedFormat");

  const downLoadAttachment = async (attachmentFileObject, detailsValues) => {
    console.log(
      selectedInvoicePeriod,
      "attachmentFileObjectattachmentFileObject",
      detailsValues
    );
    // setDownloadLoading(true);
    const zip = new JSZip();
    const folder = zip.folder();
    const filterBrokerName = selectedPeriod.filter(
      (item) =>
        item?.BillingStatementID == selectedInvoicePeriod?.BillingStatemrntId
    );
    console.log(filterBrokerName, "filterBrokerNamefilterBrokerName");
    try {
      // Fetch images and add them to the zip
      const fetchPromises = attachmentFileObject.map(async (photo, index) => {
        // setDownloadLoading(true);
        try {
          const response = await fetch(photo.Path);
          if (!response.ok) {
            throw new Error(
              `Failed to fetch ${photo.Path}. Status: ${response.status}, Status Text: ${response.statusText}`
            );
          }

          const blob = await response.blob();
          let fileName = photo.FileName;

          // Check for duplicate filenames
          let duplicateCount = 0;
          const originalFileName = fileName;

          // Ensure uniqueness by appending an index if a duplicate exists
          while (folder.files[`${fileName}`]) {
            duplicateCount += 1;
            const lastDotIndex = originalFileName.lastIndexOf(".");
            const nameWithoutExt = originalFileName.substring(0, lastDotIndex);
            const ext = originalFileName.substring(lastDotIndex); // Includes the dot
            fileName = `${nameWithoutExt} (${duplicateCount})${ext}`;
          }

          // Add file to the zip with the unique file name
          folder.file(fileName, blob);
        } catch (error) {
          console.error(`Error fetching ${photo.Path}:`, error);
        }
      });

      // Wait for all fetch promises to resolve
      await Promise.all(fetchPromises);

      // Generate the zip file and save it
      const zipBlob = await zip.generateAsync({ type: "blob" });
      saveAs(
        zipBlob,
        `${selectedInvoicePeriod.ProjectName}_${'attachments'}_${expectedFormat}.zip`
      );
    } catch (error) {
      console.error("Error generating or saving zip file:", error);
    } finally {
      // setDownloadLoading(false);
    }
  };

  const handleInvoiceCheckBoxChange = (val) => {
    var valueType = typeof val;

    const matchedArrayAll = selectedPeriod
      .filter((item) => item.StatusID === 2)
      .map((item) => item.BrokerID);

    if (
      ((invoiceCheckBox == "" && invoiceCheckBoxAll === "") ||
        typeof invoiceCheckBox == "object") &&
      val == "all"
    ) {
      const matchedArray = selectedPeriod
        .filter((item) => item.StatusID === 2)
        .map((item) => item.BrokerID);

      setInvoiceCheckBox(matchedArray);
      setInvoiceCheckBoxAll(val);
    } else if (valueType === "number") {
      setInvoiceCheckBoxAll("");
      if (typeof invoiceCheckBox === "string") {
        setInvoiceCheckBox([val]);
      }
      if (typeof invoiceCheckBox === "object") {
        const matchedArray = invoiceCheckBox.filter((item) => item == val);

        if (matchedArray && matchedArray.length > 0) {
          const updatedArray = invoiceCheckBox.filter((item) => item !== val);
          setInvoiceCheckBox(updatedArray);
        } else {
          if (matchedArrayAll.length == [...invoiceCheckBox, val].length) {
            setInvoiceCheckBoxAll("all");
          }
          setInvoiceCheckBox([...invoiceCheckBox, val]);
        }
      }
    }

    if (invoiceCheckBoxAll === "all" && valueType === "string") {
      setInvoiceCheckBox("");
      setInvoiceCheckBoxAll("");
    }
  };

  // useEffect(() => {
  //   console.log(selectedPeriod,'seleleeeeeeeee')
  //   if (selectedPeriod && selectedPeriod.length > 0 && invoiceCheckBox?.length > 0) {
  //     console.log(invoiceCheckBox,'invoiceCheckBoxinvoiceCheckBox')
  //     // Filter items where StatusID is 2
  //     const matchedArrayAll = selectedPeriod
  //       .filter(item => item.StatusID == 2)
  //       .filter(item => {
  //         // Check if item.BrokerID is a string or number, and compare accordingly
  //         if (typeof item.BrokerID === 'string' || typeof item.BrokerID === 'number') {
  //           return invoiceCheckBox.includes(item.BrokerID.toString()); // Convert to string for comparison
  //         }
  //         // If BrokerID is an array, use the 'some' logic
  //         // if (Array.isArray(item.BrokerID)) {
  //         //   return invoiceCheckBox.some(checkbox => item.BrokerID.includes(checkbox));
  //         // }
  //         // return false;
  //       });

  //     // Set the matched checkboxes
  //     setInvoiceCheckBox(matchedArrayAll.map(item => item.BrokerID));

  //     // Log for debugging
  //     console.log("Selected checkboxes:", matchedArrayAll);
  //   }
  // }, [selectedPeriod]);

  useEffect(() => {
    let InvoiceobjCount = {
      StatementOpen: 0,
      StatementReady: 0,
      InvoiceStarted: 0,
      InvoiceClosed: 0,
    };

    let StatusIdArray = selectedInvoicePeriod.StatusId.split(",");
    let trimmedStatusArr = StatusIdArray.map((str) => str.trim());

    trimmedStatusArr.forEach((item) => {
      switch (item) {
        case StatementOpen:
          InvoiceobjCount.StatementOpen++;
          break;
        case StatementReady:
          InvoiceobjCount.StatementReady++;
          break;
        case InvoiceStarted:
          InvoiceobjCount.InvoiceStarted++;
          break;
        case InvoiceClosed:
          InvoiceobjCount.InvoiceClosed++;
          break;
        default:
          // Handle unexpected values here if needed
          break;
      }
    });

    setStatusCount(InvoiceobjCount);
  }, [selectedInvoicePeriod]);

  const handleInvoiceRowClick = async (rowValue) => {

    const config = {
      method: "GET",
      url: CHECK_STATEMENT_EXIST_IN_INVOICE_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify({
          invoiceId:rowValue.InvoiceID ? rowValue.InvoiceID : rowValue.InvoiceId,
          statementId: rowValue.BillingStatementID ? rowValue.BillingStatementID  : 0
        })),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (
        parsedResponse && parsedResponse.status == 'Success' 
      ) {
        if(rowValue.IsConsolidated){
          navigate(`/consolidated-invoice-form/${rowValue.InvoiceID}`);
          if (rowValue.StatusID == 4) {
            showToast(
              "This invoice has been closed and can no longer be edited.",
              "reopenInvoice"
            );
          }
        }else{
          navigate(`/invoice-form/${rowValue.InvoiceID}`);
          if (rowValue.StatusID == 4) {
            showToast(
              "This invoice has been closed and can no longer be edited.",
              "reopenInvoice"
            );
          }
        }
      }
      
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        showToast(v.message, "error");
      }
      handleModelPopupInvoiceReload(periodIndexValues);
      //handleCloseInvoice();
    }

    console.log("VALLLLLLLLLLLLLL", rowValue)

  }

  const handleAdminInvoiceRowClick = async (rowValue) => {
  console.log(rowValue, 'rowwwwwwwwwwwwvalueeeeeeee')
    const config = {
      method: "GET",
      url: ADMIN_CHECK_STATEMENT_EXIST_IN_INVOICE_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify({
          invoiceId: rowValue?.ConsolidatedInvoiceId ? rowValue?.ConsolidatedInvoiceId : rowValue.InvoiceId ? rowValue.InvoiceId : rowValue.InvoiceID,
        })),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (
        parsedResponse && parsedResponse.status == 'Success' 
      ) {
        console.log(parsedResponse, 'parsedResponse.statusparsedResponse.status')

        if(parsedResponse.isConsolidate){
          navigate(`/consolidated-invoice-form/${rowValue?.ConsolidatedInvoiceId ? rowValue?.ConsolidatedInvoiceId : rowValue.InvoiceId ? rowValue.InvoiceId : rowValue.InvoiceID}`);
          if (rowValue.StatusID == 4) {
            showToast(
              "This invoice has been closed and can no longer be edited.",
              "reopenInvoice"
            );
          }
        }else{
          navigate(`/invoice-form/${rowValue?.ConsolidatedInvoiceId ? rowValue?.ConsolidatedInvoiceId : rowValue.InvoiceId ? rowValue.InvoiceId : rowValue.InvoiceID}`);
          if (rowValue.StatusID == 4) {
            showToast(
              "This invoice has been closed and can no longer be edited.",
              "reopenInvoice"
            );
          }
        }
      }
      
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        showToast(v.message, "error");
      }
      handleModelPopupInvoiceReload(periodIndexValues);
      //handleCloseInvoice();
    }

    console.log("VALLLLLLLLLLLLLL", rowValue)

  }

  return (
    <>
      <Dialog
        className="user-filter-popup user-filter"
        sx={{ maxWidth: "100%" }}
        fullScreen={fullScreen}
        open={open}
        aria-labelledby="responsive-dialog-title"
      >
        <Stack
          sx={{ p: "26px 34px", pb: "14px" }}
          direction="row"
          alignItems="center"
          spacing={2}
          justifyContent="space-between"
        >
          <Typography className="model-title">
            {" "}
            {selectedInvoicePeriod.ProjectName} - Billing Period (
            {moment.utc(selectedInvoicePeriod.BillingStart).local().format("MM/DD/YYYY")} -{" "}
            {moment.utc(selectedInvoicePeriod.BillingEnd).local().format("MM/DD/YYYY")})
          </Typography>

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              rowGap: "3px",
              minWidth: "123px",
              justifyContent: "flex-end",
              marginBottom: "auto",
            }}
          >
            {statusCount && statusCount.StatementOpen ? (
              <span className="invoice-ready">{statusCount.StatementOpen}</span>
            ) : (
              ""
            )}

            {statusCount && statusCount.StatementReady ? (
              <span className="invoice-open">{statusCount.StatementReady}</span>
            ) : (
              ""
            )}

            {statusCount && statusCount.InvoiceStarted ? (
              <span className="invoice-started">
                {statusCount.InvoiceStarted}
              </span>
            ) : (
              ""
            )}

            {statusCount && statusCount.InvoiceClosed ? (
              <span className="invoice-closed">
                {statusCount.InvoiceClosed}
              </span>
            ) : (
              ""
            )}
          </div>
        </Stack>
        {selectedPeriod && selectedPeriod?.length > 0 && (
          <Box sx={{ p: "0px 34px 0px 34px" }}>
            <Typography className="invoice-filter-subtitle">
            Billing Statements in Selected Period
            </Typography>
            <TableContainer
              sx={{ maxHeight: "247px" }}
              className="invoice-filter-table"
            >
              <Table
                stickyHeader
                aria-label="sticky table"
                sx={{ minWidth: 650 }}
              >
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ minWidth: "125px", pl: "0px !important" }}>
                      <FormControlLabel
                        sx={{ mr: "0px" }}
                        className="checkbox"
                        control={
                          <Checkbox
                            name="invoiceStatus"
                            onChange={() => handleInvoiceCheckBoxChange("all")}
                            // checked={invoiceCheckBoxAll === "all" ? true : false}
                            checked={
                              invoiceCheckBoxAll === "all" &&
                              (() => {
                                const matchedArrayAll = selectedPeriod
                                  .filter((item) => item.StatusID === 2)
                                  .map((item) => item.BrokerID);

                                return matchedArrayAll.length > 0; // Check if greater than zero
                              })()
                                ? true
                                : false
                            }
                            disabled={(() => {
                              const matchedArrayAll =
                                selectedPeriod &&
                                selectedPeriod
                                  .filter((item) => item?.StatusID === 2)
                                  .map((item) => item?.BrokerID);
                              return matchedArrayAll?.length === 0; // Disable if no matches found
                            })()}
                            sx={{ color: "gray", ml: "1.7px" }}
                          />
                        }
                        label=""
                      />
                      Statement ID
                    </TableCell>
                    <TableCell>Broker Name</TableCell>
                    <TableCell sx={{ minWidth: "105px" }}>
                      Invoice Number
                    </TableCell>
                    <TableCell sx={{ minWidth: "50px" }}>Hours</TableCell>
                    <TableCell sx={{ minWidth: "100px" }}>
                      Last Modified
                    </TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell sx={{ minWidth: "50px" }}>Total</TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {selectedPeriod &&
                    selectedPeriod.map((row, index) => {
                      return (
                        <TableRow
                          key={index}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell
                            sx={{ pl: "0px !important" }}
                            component="th"
                            scope="row"
                          >
                            <FormControlLabel
                              sx={{ mr: "0px" }}
                              className="checkbox"
                              control={
                                <Checkbox
                                  name="invoiceStatus"
                                  onChange={() =>
                                    handleInvoiceCheckBoxChange(row.BrokerID)
                                  }
                                  checked={
                                    row.StatusID == 2 &&
                                    invoiceCheckBox.includes(row.BrokerID)
                                      ? true
                                      : false
                                  }
                                  sx={{ color: "gray" }}
                                  disabled={row.StatusID == "2" ? false : true}
                                  style={
                                    row.StatusID == "2"
                                      ? {}
                                      : { background: "#f0f2f5" }
                                  }
                                />
                              }
                              label=""
                            />
                            {row.BillingStatementID}
                          </TableCell>
                          <TableCell
                            sx={{
                              wordBreak: "break-word",
                            }}
                            component="th"
                            scope="row"
                          >
                            {row.BrokerName}
                          </TableCell>
                          <TableCell>
                            {row.BillingStatementID && row.InvoiceID ? (
                              <Tooltip
                                title="Click here to view the invoice details"
                                arrow
                              >
                                  <span
                                    style={{
                                      color: "#007fff",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                    handleInvoiceRowClick(row)
                                  }}
                                  >
                                    #{row.InvoiceID}
                                  </span>
                              </Tooltip>
                            ) : (
                              "--"
                            )}
                          </TableCell>
                          <TableCell>
                            {row.Hours ? row.Hours?.toFixed(2) : "0.00"}
                          </TableCell>
                          <TableCell>
                            {moment(row.LastModified).utc().format("MM/DD/YYYY")}
                          </TableCell>
                          <TableCell>
                            {row.StatusID &&
                              Invoiceobj.find(
                                (item) => item.id === row.StatusID
                              )?.value}
                          </TableCell>
                          <TableCell>
                            ${row.Total ? row.Total?.toFixed(2) : "0.00"}
                          </TableCell>
                          <TableCell>
                            <Stack
                              className="action-icons"
                              direction="row"
                              spacing={1}
                            >
                              <Tooltip
                                title="Click here to get all attachments for this statement"
                                arrow
                              >
                                <img
                                  src={Download}
                                  onClick={() =>
                                    attachmentDownloadFunction(
                                      selectedInvoicePeriod,
                                      row.BillingStatementID,
                                      row.UserID,
                                      row
                                    )
                                  }
                                />
                              </Tooltip>

                              <Tooltip
                                title="Click here to view the print billing statement"
                                arrow
                              >
                                <img
                                  src={Print}
                                  onClick={() =>
                                    window.open(
                                      `/print-billing-statement/${row.BillingStatementID}`,
                                      "_blank"
                                    )
                                  }
                                />
                              </Tooltip>
                            </Stack>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )}
 {((unmatchedUniqueAdmin && unmatchedUniqueAdmin?.length > 0) || (uniqueadminSingle && uniqueadminSingle?.length > 0)) && (
  <Box sx={{ p: "0px 34px 0px 34px" }}>
    <Typography sx={{ mt: "8px" }} className="invoice-filter-subtitle">
      Admin-Generated
    </Typography>
    <TableContainer sx={{ ml: "24px" }} className="invoice-filter-table">
      <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 650 }}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ minWidth: "125px" }}>Admin Generated</TableCell>
            <TableCell sx={{ minWidth: "105px" }}>Invoice Number</TableCell>
            <TableCell sx={{ minWidth: "50px" }}>Hours</TableCell>
            <TableCell sx={{ minWidth: "100px" }}>Created Date</TableCell>
            <TableCell>Status</TableCell>
            <TableCell sx={{ minWidth: "50px" }}>Total</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        {/* {uniqueadminSingle?.length > 0 && uniqueadminSingle.map((item) => (
            <TableRow key={item.InvoiceId}>
              <TableCell component="th" scope="row">Admin</TableCell>
              <TableCell>
                {item.InvoiceId ? (
                  <Tooltip title="Click here to view the invoice details" arrow>
                    <span
                      style={{ color: "#007fff", cursor: "pointer" }}
                      onClick={() => handleAdminInvoiceRowClick(item)}
                    >
                      #{item.InvoiceId}
                    </span>
                  </Tooltip>
                ) : '--'}
              </TableCell>
              <TableCell>{item.BrokerHours ? item.BrokerHours?.toFixed(2) : "0.00"}</TableCell>
              <TableCell>
                {item.CreateDate
                  ? moment(item.CreateDate).utc().format("MM/DD/YYYY")
                  : moment(item.LastModified).utc().format("DD/MM/YYYY")}
              </TableCell>
              <TableCell>
                {item.StatusID && Invoiceobj.find((row) => row.id === item.StatusID)?.value}
              </TableCell>
              <TableCell>
                ${item.InvoiceTotal ? item.InvoiceTotal?.toFixed(2) : "0.00"}
              </TableCell>
            </TableRow>
          ))} */}
          {combinedUnmatchedUniqueArray?.length > 0 && combinedUnmatchedUniqueArray.map((item) => (
            <TableRow key={item.ConsolidatedInvoiceId || item.InvoiceId}>
              <TableCell component="th" scope="row">Admin</TableCell>
              <TableCell>
                {item.ConsolidatedInvoiceId ? (
                  <Tooltip title="Click here to view the invoice details" arrow>
                    <span
                      style={{ color: "#007fff", cursor: "pointer" }}
                      onClick={() => handleAdminInvoiceRowClick(item)}
                    >
                      #{item.ConsolidatedInvoiceId}
                    </span>
                  </Tooltip>

                ) : item.InvoiceId ? (
                  <Tooltip title="Click here to view the invoice details" arrow>
                    <span
                      style={{ color: "#007fff", cursor: "pointer" }}
                      onClick={() => handleAdminInvoiceRowClick(item)}
                    >
                      #{item.InvoiceId}
                    </span>
                  </Tooltip>
                ) :
                
                "--"}
              </TableCell>
              <TableCell>{item.BrokerHours ? item.BrokerHours?.toFixed(2) : "0.00"}</TableCell>
              <TableCell>
                {item.CreateDate
                  ? moment(item.CreateDate).utc().format("MM/DD/YYYY")
                  : moment(item.LastModified).utc().format("DD/MM/YYYY")}
              </TableCell>
              <TableCell>
                {item.StatusID && Invoiceobj.find((row) => row.id === item.StatusID)?.value}
              </TableCell>
              <TableCell>
                ${item.InvoiceTotal ? item.InvoiceTotal?.toFixed(2) : "0.00"}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </Box>
)}

        <DialogActions
          sx={{ justifyContent: "flex-start", p: "20px 34px", pt: "18px" }}
        >
          {invoiceCheckBox.length > 0 ? (
            <Button
              className="filter-btn"
              onClick={() => createCloseInvoice(true, invoiceCheckBox)}
            >
              Create
            </Button>
          ) : (
            ""
          )}
          <Button className="cancel-btn" onClick={handleCloseInvoice}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
